export const enneagramQuestions = [
  // 1번 유형 문제들
  {
    text: "나는 남들보다 자주 속에서 화가 난다.",
    type: 1
  },
  {
    text: "나는 완벽을 위해 끝까지 노력한다.",
    type: 1
  },
  {
    text: "나는 때때로 융통성이 없고 원칙을 고수한다.",
    type: 1
  },
  {
    text: "나는 옳고 그름이 분명하여 때로는 비판적이다.",
    type: 1
  },
  {
    text: "나는 나의 양심에 따라 행동한다.",
    type: 1
  },

  // 2번 유형 문제들
  {
    text: "나의 관심사는 다른 사람을 도와주는 것이다.",
    type: 2
  },
  {
    text: "나는 다른 사람들을 자주 칭찬한다.",
    type: 2
  },
  {
    text: "나는 다른 사람의 감정을 위해서 나의 감정을 억누른다.",
    type: 2
  },
  {
    text: "나는 친구들에게 좋은 사람으로 보이기 위해 노력한다.",
    type: 2
  },
  {
    text: "나는 다른 사람들과 함께 일하면 기분이 좋다.",
    type: 2
  },

  // 3번 유형 문제들
  {
    text: "나는 과정보다 목표달성이 중요하다.",
    type: 3
  },
  {
    text: "나는 지나치게 경쟁심이 강하다.",
    type: 3
  },
  {
    text: "나는 맡은 일을 효율적인 방법으로 잘 처리한다.",
    type: 3
  },
  {
    text: "나는 뒤떨어지지 않기 위해 항상 노력한다.",
    type: 3
  },
  {
    text: "나는 능력을 인정받기 위해 끊임없이 변화하는 것이 좋다.",
    type: 3
  },

  // 4번 유형 문제들
  {
    text: "나는 예술가적 기질이 있다.",
    type: 4
  },
  {
    text: "나는 남들과 다른 독특한 감정을 가지고 있다.",
    type: 4
  },
  {
    text: "나는 분위기에 따라 감정이 자주 변한다.",
    type: 4
  },
  {
    text: "나는 별다른 일이 없어도 우울감을 자주 느낀다.",
    type: 4
  },
  {
    text: "나는 평범하게 사는 것이 싫다.",
    type: 4
  },

  // 5번 유형 문제들
  {
    text: "나는 문제가 생기면 그 문제가 풀릴 때까지 그것만 생각한다.",
    type: 5
  },
  {
    text: "나는 정보를 탐색하고 지식을 쌓는 것에 시간을 할애한다.",
    type: 5
  },
  {
    text: "나는 지적이고 냉철하게 관찰하는 편이다.",
    type: 5
  },
  {
    text: "나는 모든 것을 머리로 이해하고 판단한다.",
    type: 5
  },
  {
    text: "나는 생각에 깊게 빠지는 일이 많은 편이다.",
    type: 5
  },

  // 6번 유형 문제들
  {
    text: "나는 가족도 가끔 의심하는 경향이 있다.",
    type: 6
  },
  {
    text: "조직에서 내가 주도하여 선택하는 일은 피하고싶다",
    type: 6
  },
  {
    text: "나는 모든 일에 안전이 중요하다고 생각한다.",
    type: 6
  },
  {
    text: "나는 결과가 나쁠까봐 결정을 못 내리고 질질 끈다.",
    type: 6
  },
  {
    text: "나는 창의적인 것보다는 정해진 대로 하는 것을 더 잘 한다.",
    type: 6
  },

  // 7번 유형 문제들
  {
    text: "나는 끊임없이 변화하는 것이 좋다.",
    type: 7
  },
  {
    text: "나는 자극적이고 흥분되는 활동을 좋아한다.",
    type: 7
  },
  {
    text: "나는 항상 새로운 경험을 하려고 한다.",
    type: 7
  },
  {
    text: "나는 반복되는 일이 지루해서 지속하지 못한다",
    type: 7
  },
  {
    text: "나는 참을성이 없는 편이다.",
    type: 7
  },

  // 8번 유형 문제들
  {
    text: "나는 내 맘대로 결정하려는 경향이 있다.",
    type: 8
  },
  {
    text: "나는 항상 강해야 한다고 생각한다.",
    type: 8
  },
  {
    text: "나는 내가 주장하는 것을 강하게 밀고 나간다.",
    type: 8
  },
  {
    text: "나는 강한 자신감으로 다른 사람들을 설득한다.",
    type: 8
  },
  {
    text: "나는 지도자의 기질이 있다.",
    type: 8
  },

  // 9번 유형 문제들
  {
    text: "나는 해야할 일을 미루는 편이다.",
    type: 9
  },
  {
    text: "나는 다른 사람들의 의견을 잘 따른다.",
    type: 9
  },
  {
    text: "나는 남의 일에 관심이 없다.",
    type: 9
  },
  {
    text: "나는 조화롭게 살아가는 평화주의자다.",
    type: 9
  },
  {
    text: "나는 간섭하지도 간섭받고 싶지도 않다.",
    type: 9
  }
].sort(() => Math.random() - 0.5); // 문제 순서를 랜덤하게 섞음